import { ReactNode } from "react";

interface NotificationCardProps {
  icon: ReactNode;
  title: string;
  titleColor?: string;
  description: string;
  borderColor?: string;
  bgColor?: string;
}

export const NotificationCard = ({
  icon,
  title,
  titleColor,
  description,
  borderColor = "border-amber-400",
  bgColor = "bg-gray-50",
}: NotificationCardProps) => (
  <div className="flex items-center gap-3 border border-gray-[#EEEEEE] rounded-lg p-4 mb-10 shadow-sm">
    {icon}
    <div className="">
      <h3
        className={`${
          titleColor ? titleColor : "text-gray-900"
        } text-xs font-semibold`}
      >
        {title}
      </h3>
      <p className="text-gray-700 text-[11px] mt-1">{description}</p>
    </div>
  </div>
);
